import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/layouts`, options)
    .then(response => {
      return {
        list: response.data.data,
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/layouts/${id}`, options)
    .then(response => {
      let layout = jsona.deserialize(response.data);
      delete layout.links;
      return layout;
    });
}

function add(layout) {
  const payload = jsona.serialize({
    stuff: layout,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/layouts`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(layout) {
  const payload = jsona.serialize({
    stuff: layout,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/layouts/${layout.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function activate(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.put(`${url}/layouts/activate/${id}`, options);
}

function deactivate(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.put(`${url}/layouts/deactivate/${id}`, options);
}

function addLayout(layout) {
  const payload = jsona.serialize({
    stuff: layout,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/layouts/design`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function listActive(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/layouts/listActive`, options).then(response => {
    return {
      listActive: response.data.data,
    };
  });
}

export default {
  list,
  get,
  add,
  update,
  activate,
  deactivate,
  addLayout,
  listActive
};

